"use client";
import { useState } from "react";
import { useRouter } from "next/navigation";

export default function Button({
  children,
  type,
  onClick,
  href,
  className = "",
  color,
}) {
  const [clicked, setClicked] = useState(false);
  const router = useRouter();

  const defaultBg = clicked
    ? "bg-darkaccentyellow"
    : "bg-accentyellow hover:bg-darkaccentyellow";

  const bgClass = color || defaultBg;

  // Check if custom margin classes are provided
  const hasCustomMargin = /\b(m-|mt-|my-|margin)/i.test(className);
  const defaultMargin = hasCustomMargin ? "" : "mt-[40px]";

  return (
    <div
      onClick={() => {
        if (onClick) onClick();
        setClicked(true);
        if (href) router.push(href);
      }}
      className={`px-5 py-3 ${defaultMargin} w-fit font-semibold text-black rounded-[10px] m-auto cursor-pointer text-center ${bgClass} ${className}`}
    >
      {children}
    </div>
  );
}
